import ReactDOM from "react-dom";
import CompassLoader from "../Components/CompassLoader/CompassLoader";
import { useLoadingQuote } from "../Components/CompassLoader/useLoadingQuote";
import classes from "./style.module.scss";

/**
 * Used in 15+ places across the app. `fullScreen` (default true, for
 * backward compatibility with existing whole-page loading states)
 * covers the viewport with a real blurred backdrop. Pass
 * `fullScreen={false}` for anything loading inside a modal, drawer, or
 * page section — it renders inline instead, sized down, with no
 * overlay at all, since it isn't covering anything that needs
 * obscuring in the first place.
 *
 * The fullScreen variant is portaled straight to document.body — same
 * reasoning as the compare-providers modal earlier in this project.
 * Every page is wrapped in RouteTransition, which plays a CSS
 * `animation` involving `transform` on mount; any element with an
 * active transform becomes a containing block for position:fixed
 * descendants, so without the portal, a loading state that first
 * appears during that transition renders relative to the animating
 * page wrapper instead of the real viewport — exactly the "loader
 * shows up below the fold, have to scroll to see it" bug this fixes.
 */
export const LoadingIndicator = ({ height, width, context = "general", fullScreen = true }) => {
  const quote = useLoadingQuote(context);
  const size = height || width || (fullScreen ? 100 : 64);

  const content = (
    <div className={fullScreen ? classes["loader-indicator"] : classes["loader-indicator-inline"]}>
      <div className={classes["loader-content"]}>
        <CompassLoader size={size} />
        <p className={fullScreen ? classes["loader-quote"] : classes["loader-quote-sm"]}>{quote}</p>
      </div>
    </div>
  );

  return fullScreen ? ReactDOM.createPortal(content, document.body) : content;
};

export default LoadingIndicator;